"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _react = _interopRequireDefault(require("react"));
var _focusMode = require("../focusMode");
var _BaseButton = require("./BaseButton");
/** @jsxRuntime classic */
/** @jsx jsx */

const Link = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    appearance = "link",
    ...props
  } = _ref;
  const {
    focusMode
  } = (0, _focusMode.useFocusMode)({
    isDisabled: appearance !== "button-borderless"
  });
  return (0, _core.jsx)(_BaseButton.BaseButton, (0, _extends2.default)({}, props, {
    appearance: appearance,
    innerRef: ref,
    focusMode: focusMode,
    renderAs: "a"
  }));
});
exports.Link = Link;
//# sourceMappingURL=Link.js.map